import Icon from '../components/Icon.vue'

Icon.register({
  trophy: {
    width: 576,
    height: 512,
    paths: [
      {
        d: 'M552 64c13.3 0 24 10.7 24 24v56c0 35.7-22.6 72.4-61.9 100.7-31.4 22.7-69.7 37.1-110 41.7-31.4 52.1-68.1 73.6-68.1 73.6v72h48c35.3 0 64 20.7 64 56v12c0 6.6-5.4 12-12 12h-296c-6.6 0-12-5.4-12-12v-12c0-35.3 28.7-56 64-56h48v-72s-36.7-21.5-68.1-73.6c-40.2-4.6-78.5-19-110-41.7-39.4-28.3-61.9-65-61.9-100.7v-56c0-13.3 10.7-24 24-24h104v-40c0-13.3 10.7-24 24-24h272c13.3 0 24 10.7 24 24v40h104zM99.3 192.8c12.5 9 26.6 16.2 41.7 21.4-7-25-11.8-53.6-12.8-86.2h-64.2v16c0 11.6 10.9 31.2 35.3 48.8zM512 144v-16h-64.3c-1 32.6-5.8 61.2-12.8 86.2 15.1-5.2 29.3-12.4 41.8-21.4 17.6-12.7 35.3-32.7 35.3-48.8z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/trophy.js
// module id = 2034
// module chunks = 0